<template>
  <modal ref="loadingModal" white-blur no-close-on-backdrop>
    <template v-slot:content>
      <div class="loading-modal">
        <svg
          id="loading-spinner"
          width="80"
          height="80"
          viewBox="0 0 80 80"
          fill="none"
        >
          <circle
            id="loading-circle-large"
            cx="40"
            cy="40"
            r="36"
            stroke="#01E47A"
            stroke-width="6"
          />
        </svg>
        <p class="loading-modal__text">{{ data.loadingVideo }}</p>
      </div>
    </template>
  </modal>
</template>

<script>
import { ref, toRefs, watch } from '@vue/composition-api';
import { Modal } from '@discoveryeducation/components';
export default {
  name: 'LoadingModal',
  components: { Modal },
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { root }) {
    const loadingModal = ref(null);
    const { isLoading } = toRefs(props);

    const showModal = () => {
      root.getAudioById('button-click').play();
      loadingModal.value.show();
    };

    const hideModal = () => {
      loadingModal.value.hide();
    };

    watch(isLoading, (newValue) => {
      newValue ? showModal() : hideModal();
    });

    return { loadingModal, showModal, hideModal };
  },
};
</script>

<style lang="stylus">
color-white = colors.white
color-black-100 = colors.black-100
custom-easing = cubic-bezier(0.445, 0.05, 0.55, 0.95)
spinner-stroke = 210
spinner-stroke-animate = 190
spinner-rotate = 25deg
spinner-rotate-origin = -32deg

.loading-modal
  background-color color-white
  width 346px
  height 257px
  border-radius radius-modal
  box-shadow modal-shadow
  display flex
  flex-direction column
  align-items center
  justify-content center

  &__text
    font-family Nunito-Bold
    font-size 22px
    line-height 30px
    color color-black-100
    padding-top 20px

// Spinner container
#loading-spinner
	display block
	margin 0 auto
	animation loading-spinner-spin 2s linear infinite
	will-change transform

@keyframes loading-spinner-spin {
	from {
		transform rotate(0deg)
	}
	to {
		transform rotate(360deg)
	}
}

#loading-circle-large
	stroke-dasharray spinner-stroke
	stroke-dashoffset spinner-stroke
	stroke-linecap round
	animation loading-spinner-large 1.7s custom-easing infinite
	transform translateZ(0)
	transform-origin center
	will-change stroke-dashoffset

@keyframes loading-spinner-large {
	0% {
		stroke-dashoffset spinner-stroke-animate
		transform scaleY(1)
	}
	49.99% {
		stroke-dashoffset 0
		transform scaleY(1)
	}
	50% {
		stroke-dashoffset 0
		transform scaleY(-1) rotate(spinner-rotate)
	}
	100% {
		stroke-dashoffset spinner-stroke-animate
		transform scaleY(-1) rotate(spinner-rotate-origin)
	}
}
</style>
